import { API_CLIENTS_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import type { GetPingResponse } from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  children?: (data: GetPingResponse) => ReactElement
}

const PingApiClientsService = ({
  children
}: Props) => {
  const url = `${API_CLIENTS_SERVICE}/health/ready`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      url={url}
    />
  )
}

export default PingApiClientsService
